// The one place a role id becomes the words people read: every page that shows or offers a role (Admin →
// Organizations, the Profile, the permissions reference, Identity and SCIM, the share dialogs, the audit log)
// renders roleLabel(role), never the id. Ids stay ids everywhere else (the api, the URL, data-testid).

const LABELS: Readonly<Record<string, string>> = {
  platform_admin: 'Platform Admin',
  org_admin: 'Organization Admin',
  member: 'Member',
  app_user: 'App User',
  viewer: 'Viewer',
  editor: 'Editor',
};

/** "Organization Admin" for org_admin; an unknown id is shown as words ("some_role" → "Some Role"). */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return (
    LABELS[role] ??
    role
      .split(/[_\s]+/)
      .filter(Boolean)
      .map((w) => w[0]!.toUpperCase() + w.slice(1))
      .join(' ')
  );
}

/** Every role id in a text ("org_admin manages…") replaced by its label, for copy that names roles. */
export function withRoleLabels(text: string): string {
  return text.replace(/\b(platform_admin|org_admin|app_user)\b/g, (id) => roleLabel(id));
}
